"use client";

import ClientFontLoader from "./ClientFontLoader";
import dynamic from "next/dynamic";
import "react-toastify/dist/ReactToastify.css";
import SanityConsoleGuard from "@/components/common/SanityConsoleGuard";
import AnalyticsTracker from "@/components/common/AnalyticsTracker";
import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";

// Dynamically import components that are not critical for the initial render
const Footer = dynamic(() => import("@/components/Footer"));
const ChatWidget = dynamic(() => import("@/components/chat/ChatWidget"));

// This component requires browser APIs, so we disable SSR for it.
const ToastContainer = dynamic(
  () => import("react-toastify").then((mod) => mod.ToastContainer),
  { ssr: false },
);

export default function ClientLayout() {
  const [isStudioPage, setIsStudioPage] = useState(false);
  const [studioLoaded, setStudioLoaded] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    // Check if we're on the studio page
    setIsStudioPage(pathname?.startsWith("/studio") || false);

    // Check if studio is loaded
    const checkStudioLoaded = () => {
      if (typeof window !== "undefined") {
        setStudioLoaded(window.studioLoaded || false);
      }
    };

    checkStudioLoaded();

    // Set up interval to check studio loading status
    const interval = setInterval(checkStudioLoaded, 100);

    return () => clearInterval(interval);
  }, [pathname]);

  const shouldShowFooter = !isStudioPage || studioLoaded;

  return (
    <>
      <SanityConsoleGuard />
      <AnalyticsTracker />
      <ClientFontLoader />
      <ToastContainer
        autoClose={3000}
        theme="dark"
        closeOnClick
        position="top-right"
      />
      <ChatWidget />
      {shouldShowFooter && <Footer />}
    </>
  );
}
